import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

type Props = { children: ReactNode };
type State = { hasError: boolean; error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("App error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div
          className="min-h-screen flex items-center justify-center p-6"
          style={{ background: "#f4f1ea", color: "#1c1c1c" }}
        >
          <div className="max-w-lg">
            <h1 className="text-xl font-semibold mb-2">Something went wrong</h1>
            <p className="text-sm mb-4 font-mono break-all">
              {this.state.error.message}
            </p>
            <p className="text-sm opacity-80">
              Check the browser console (F12 → Console) for details.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
